import React, { forwardRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import useDialog from '../dialog/useDialog';
import Button from '../button/button';
import PanelCardFooter from '../panel-card/panel-card-footer';
import FileUploader from '../file-uploader/file-uploader';
import Dialog from '../dialog/dialog';
import PanelCard from '../panel-card/panel-card';
import UploadDocument from '../add-order-lines/uploadDocument';

const ForwarderUploadDocument = forwardRef(
  (
    {
      id,
      handleUploadDocument,
      uploadedAttachement,
      errorMessage,
      t,
      disabledRemove,
      disableuploadbutton,
      isRequired,
      label,
      removeDocumentAPI,
    },
    ref
  ) => {
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [attachment, setAttachment] = useState([]);
    const [disableButton, setDisableButton] = useState(false);
    const [isDocumentRemoved, setIsDocumentRemoved] = useState(false);

    const { isShowing: isActivateUploadDislog, toggle: toggleUploadDialog } =
      useDialog();

    useEffect(() => {
      if (typeof removeDocumentAPI === 'function') {
        setAttachment([]);
      }
    }, [isActivateUploadDislog]);
    const getLoaderStatus = (e) => {
      setDisableButton(e);
    };

    let resultArray = [];
    const handleResultArray = () => {
      resultArray = [];
      attachment?.forEach((attachmentItem) => {
        resultArray.push({
          docId: attachmentItem?.docId,
          url: attachmentItem?.url,
          size: attachmentItem.fileSize,
          path: attachmentItem.filePath,
          originalName: attachmentItem.originalFileName,
          mimeType: attachmentItem.fileType,
        });
      });
    };
    handleResultArray();

    useEffect(() => {
      if (isDocumentRemoved) {
        handleUploadDocument(id, resultArray);
      }
      return () => {
        setIsDocumentRemoved(false);
      };
    }, [isDocumentRemoved]);

    const removeDocument = ({ docId }) => {
      const targetAttachment = attachment?.find(
        (item) => item?.docId === docId
      );

      if (targetAttachment) {
        setIsDocumentRemoved(true);
        setAttachment((prev) => {
          const updatedPrev = prev?.filter((item) => item?.docId !== docId);
          return updatedPrev;
        });
        setSelectedFiles((prev) => {
          const updatedPrev = prev?.filter(
            (item) => item?.name !== targetAttachment.originalFileName
          );
          return updatedPrev;
        });
      }
    };

    return (
      <>
        <FileUploader
          className="quatation"
          label={
            label ||
            t(
              'managebookingscreen.bookingdetails.sendquotationbtn.sendquotationtab.uploadquotedocument'
            )
          }
          required={isRequired}
          onClick={toggleUploadDialog}
          uploadedAttachement={uploadedAttachement}
          errorMessage={errorMessage}
          removeDocument={removeDocumentAPI ?? removeDocument}
          disabledRemove={disabledRemove}
          t={t}
          isdisableduploadbutton={disableuploadbutton}
          ref={ref}
        />
        <Dialog
          isShowing={isActivateUploadDislog}
          hide={toggleUploadDialog}
          placement="middle"
          maskZindex={1043}
        >
          <PanelCard
            cardTitle={t(
              'managebookingscreen.bookingdetails.sendquotationbtn.sendquotationtab.uploaddocuments'
            )}
            noShadow
            border
          >
            <UploadDocument
              selectedFiles={selectedFiles}
              Width="27.778vw"
              onUpload={(data) => {
                setAttachment(data);
              }}
              attachment={attachment}
              getLoaderStatus={getLoaderStatus}
              setSelectedFiles={setSelectedFiles}
              multiple
            />
            <PanelCardFooter align="right">
              <Button
                label={t(
                  'managebookingscreen.bookingdetails.sendquotationbtn.sendquotationtab.add'
                )}
                color="submit"
                disabled={disableButton}
                onClick={() => {
                  toggleUploadDialog();
                  handleUploadDocument(id, resultArray);
                }}
              >
                Submit
              </Button>
            </PanelCardFooter>
          </PanelCard>
        </Dialog>
      </>
    );
  }
);

export default ForwarderUploadDocument;

ForwarderUploadDocument.propTypes = {
  id: PropTypes.number.isRequired,
  handleUploadDocument: PropTypes.func,
  uploadedAttachement: PropTypes.instanceOf(Array),
  errorMessage: PropTypes.string,
  t: PropTypes.func,
  disabledRemove: PropTypes.bool,
  disableuploadbutton: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  removeDocumentAPI: PropTypes.func,
};
ForwarderUploadDocument.defaultProps = {
  handleUploadDocument: () => {},
  uploadedAttachement: [],
  errorMessage: '',
  t: () => {},
  disabledRemove: false,
  disableuploadbutton: false,
  isRequired: true,
  label: '',
  removeDocumentAPI: undefined,
};
